import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class StockTakeSessionEventQueryCriteriaClass extends BaseCriteriaModel {
  guid_hdr?: Optional<string> = Optional.empty();
  guid_bin?: Optional<string> = Optional.empty();
  guid_device?: Optional<string> = Optional.empty();
  guid_record?: Optional<string> = Optional.empty();
  action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  foreign_table?: Optional<string> = Optional.empty();
  foreign_key?: Optional<string> = Optional.empty();

}

export class StockTakeSessionEventCriteriaModelQuery {
  query = '';

  constructor(stockTakeSessionEventCriteriaModel: StockTakeSessionEventQueryCriteriaClass) {

    if (!stockTakeSessionEventCriteriaModel) {
      return;
    }

    this.query += stockTakeSessionEventCriteriaModel.guid_hdr.filter(x => x !== '').map(x => '&guid_hdr=' + x).orElse('');
    this.query += stockTakeSessionEventCriteriaModel.guid_bin.filter(x => x !== '').map(x => '&guid_bin=' + x).orElse('');
    this.query += stockTakeSessionEventCriteriaModel.guid_device.filter(x => x !== '').map(x => '&guid_device=' + x).orElse('');
    this.query += stockTakeSessionEventCriteriaModel.guid_record.filter(x => x !== '').map(x => '&guid_record=' + x).orElse('');
    this.query += stockTakeSessionEventCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');
    this.query += stockTakeSessionEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += stockTakeSessionEventCriteriaModel.foreign_table.filter(x => x !== '').map(x => '&foreign_table=' + x).orElse('');
    this.query += stockTakeSessionEventCriteriaModel.foreign_key.filter(x => x !== '').map(x => '&foreign_key=' + x).orElse('');

    this.query += '&status=' + stockTakeSessionEventCriteriaModel.status;
    this.query += '&orderBy=' + stockTakeSessionEventCriteriaModel.orderBy;
    this.query += '&order=' + stockTakeSessionEventCriteriaModel.order;
    this.query += '&offset=' + stockTakeSessionEventCriteriaModel.offset + '&limit=' + stockTakeSessionEventCriteriaModel.limit;
  }
}
